let obj = {
    locales: [],
    image: '',
    status: 0
}
export default obj;